import { Plugin } from 'ckeditor5';

export default class MentionPlugin extends Plugin {
    static get pluginName() {
        return 'MentionPlugin';
    }

    static get requires() {
        return [];
    }
}

// Helper for user feed
export function getFeedItems(queryText) {
    return new Promise((resolve) => {
        $.ajax({
            url: '/comments/mention/' + queryText,
            method: 'GET',
            success: function (response) {
                const items = response.users.map(user => ({
                    ...user,
                    id: '@' + user.name
                }));
                resolve(items);
            }
        });
    });
}

// Helper for image feed
export function getFeedImages(queryText) {
    return new Promise((resolve) => {
        $.ajax({
            url: '/images/mention/' + queryText,
            method: 'GET',
            success: function (response) {
                const items = response.images.map(image => ({
                    ...image,
                    id: '#' + image.id
                }));
                resolve(items);
            }
        });
    });
}

// Custom renderer for user mention
export function customItemRenderer(item) {
    const itemElement = document.createElement('span');
    itemElement.classList.add('custom-item', 'ckeditor-mention-exhibit');
    itemElement.textContent = `${item.name} `;
    itemElement.setAttribute('data-username', item.username);

    const usernameElement = document.createElement('span');
    usernameElement.classList.add('custom-item-username');
    usernameElement.textContent = '(@' + item.username + ')';

    itemElement.appendChild(usernameElement);

    return itemElement;
}

// Custom renderer for image mention
export function customImageRenderer(item) {
    const itemElement = document.createElement('span');
    itemElement.classList.add('custom-item', 'ckeditor-mention-exhibit');
    let originalString = `${item.title} `;
    itemElement.textContent = originalString.replace(/(<([^>]+)>)/gi, "");
    itemElement.setAttribute('data-title', item.title);

    return itemElement;
}
